"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudentNotificationPreferences = void 0;
// StudentNotificationPreferences.tsx
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var NotificationsOutlined_1 = __importDefault(require("@mui/icons-material/NotificationsOutlined"));
var SmartphoneOutlined_1 = __importDefault(require("@mui/icons-material/SmartphoneOutlined"));
var DesktopWindowsOutlined_1 = __importDefault(require("@mui/icons-material/DesktopWindowsOutlined"));
var EmailOutlined_1 = __importDefault(require("@mui/icons-material/EmailOutlined"));
var Lang_js_1 = require("../../Lang.js");
var usePreferencesState_1 = __importDefault(require("../hooks/usePreferencesState"));
var material_2 = require("@mui/material");
var preferencesStore_1 = require("../storage/preferencesStore");
var api_1 = require("../api");
var Toast_1 = __importDefault(require("../../Generic/Toast"));
var KindChannelToggles_1 = __importDefault(require("./KindChannelToggles"));
var StudentNotificationPreferences = function (_a) {
    var userId = _a.userId;
    var enabledCount = (0, usePreferencesState_1.default)(userId).enabledCount;
    var kinds = (0, react_1.useSyncExternalStore)(preferencesStore_1.subscribePreferences, preferencesStore_1.getKinds);
    var webKindKeys = (0, react_1.useMemo)(function () { return kinds.filter(function (k) { return k.channels.includes('database'); }).map(function (k) { return k.kind; }); }, [kinds]);
    var pushKindKeys = (0, react_1.useMemo)(function () { return kinds.filter(function (k) { return k.channels.includes('push'); }).map(function (k) { return k.kind; }); }, [kinds]);
    var emailKindKeys = (0, react_1.useMemo)(function () { return kinds.filter(function (k) { return k.hasEmailList; }).map(function (k) { return k.kind; }); }, [kinds]);
    var _b = (0, preferencesStore_1.useNotificationLanguageStore)(), language = _b.language, setLanguage = _b.setLanguage;
    var handleLanguageChange = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var newLanguage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    newLanguage = event.target.value;
                    setLanguage(newLanguage);
                    return [4 /*yield*/, (0, api_1.updateLanguage)(newLanguage)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(material_1.Box, null,
        react_1.default.createElement(Toast_1.default, null),
        react_1.default.createElement(material_1.Tooltip, { title: (0, Lang_js_1.__)('This language will be used for all of your notifications'), placement: "top-start", arrow: true },
            react_1.default.createElement(material_2.FormControl, { sx: {
                    mb: 2,
                    minWidth: 200,
                } },
                react_1.default.createElement(material_2.InputLabel, { id: "language-select-label" }, (0, Lang_js_1.__)('Notifications Language')),
                react_1.default.createElement(material_2.Select, { labelId: "language-select-label", id: "language-select", value: language, label: (0, Lang_js_1.__)('Notifications Language'), onChange: handleLanguageChange },
                    react_1.default.createElement(material_2.MenuItem, { value: "en" }, "English"),
                    react_1.default.createElement(material_2.MenuItem, { value: "es" }, "Espa\u00F1ol")))),
        react_1.default.createElement(material_1.Box, { sx: { mb: 2 } },
            react_1.default.createElement(material_1.Stack, { direction: "row", spacing: 1, sx: { mt: 1 } },
                react_1.default.createElement(material_1.Chip, { icon: react_1.default.createElement(EmailOutlined_1.default, null), label: (0, Lang_js_1.__)('Email') + ": ".concat(enabledCount('email', emailKindKeys), "/").concat(emailKindKeys.length), variant: "outlined" }),
                react_1.default.createElement(material_1.Chip, { icon: react_1.default.createElement(DesktopWindowsOutlined_1.default, null), label: (0, Lang_js_1.__)('Web') + ": ".concat(enabledCount('database', webKindKeys), "/").concat(webKindKeys.length), variant: "outlined" }),
                react_1.default.createElement(material_1.Chip, { icon: react_1.default.createElement(SmartphoneOutlined_1.default, null), label: (0, Lang_js_1.__)('Mobile') + ": ".concat(enabledCount('push', pushKindKeys), "/").concat(pushKindKeys.length), variant: "outlined" }))),
        react_1.default.createElement(material_1.Grid, { container: true, spacing: 2 }, kinds.map(function (k) { return (react_1.default.createElement(material_1.Grid, { item: true, xs: 12, md: 6, key: k.kind },
            react_1.default.createElement(material_1.Card, { variant: "outlined", className: "msia-prefCard" },
                react_1.default.createElement(material_1.CardContent, { sx: { p: 2.25 } },
                    react_1.default.createElement(material_1.Stack, { direction: "row", spacing: 1, alignItems: "center", sx: { mb: 1 } },
                        react_1.default.createElement(NotificationsOutlined_1.default, { fontSize: "small" }),
                        react_1.default.createElement(material_1.Typography, { variant: "subtitle1", sx: { fontWeight: 600 } }, k.title)),
                    react_1.default.createElement(material_1.Typography, { variant: "body2", color: "text.secondary", sx: { mb: 2 } }, k.description),
                    react_1.default.createElement(material_1.Divider, { sx: { mb: 1.5 } }),
                    react_1.default.createElement(KindChannelToggles_1.default, { kind: k.kind, userId: userId }))))); }))));
};
exports.StudentNotificationPreferences = StudentNotificationPreferences;
exports.default = exports.StudentNotificationPreferences;
